<nb-card [nbSpinner]="loading()">
  <nb-card-header>
    <div class="header">
      <span>{{buildingIdentifier()}}</span>
      @if (building()?.buildingCondition?.conditionValue; as condition) {
        <wr-building-condition [condition]="condition"
                               [fontSize]="'1.5rem'">
        </wr-building-condition>
      }
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class="addresses">
      <span>{{building()?.sectionText}}</span>
    </div>
    @if (lastInspection(); as inspection) {
      <div class="last-inspection">
        <div>
          <span>Rundgang vom {{inspection.fromTimestamp | date: 'dd.MM.yyyy'}}</span>
          <wr-status-text [status]="inspection.status"></wr-status-text>
        </div>
        <button nbButton
                routerLink="/inspection/{{inspection.id}}"
                nbTooltip="Zum Rundgang"
                nbTooltipStatus="basic">
          <nb-icon icon="external-link-outline" pack="eva"></nb-icon>
        </button>
      </div>
    } @else if (!loading()) {
      Kein Rundgang gefunden
    }
  </nb-card-body>
</nb-card>
